import React from 'react';
import { ReactComponent as Mascot } from '../assets/lg-lap.svg';

interface EmptyStateProps {
  title: string;
  message: string;
  action?: React.ReactNode; // Prop mới, tùy chọn
}

const EmptyState: React.FC<EmptyStateProps> = ({ title, message, action }) => {
  return (
    <div className="empty-state-container">
      <Mascot className="empty-state-mascot" />
      <h3 className="empty-state-title">{title}</h3>
      <p className="empty-state-message">{message}</p>
      
      {/* Hiển thị nút nếu nó được truyền vào */}
      {action && <div className="empty-state-action">{action}</div>}
    </div>
  );
};

export default EmptyState;